/** Globale Variablen **/

'use strict';

import jQuery from 'jquery';
import * as Tools from './tools.js';

jQuery(function($) {
    $(document).ready(function() {
        /**
         * Modules
         */
        // Moudles START
        document.body.addEventListener('click', Tools.delegate('[data-toggle]', e => {
            let targetId = e.closestMatch.getAttribute('href').split('#')[1];
            let toggleClass = e.closestMatch.dataset.toggle;
            let target = document.getElementById(targetId);

            if (target && toggleClass) {
                target.classList.toggle(toggleClass);
                e.target.closest('[data-toggle]').classList.toggle('toggle');
            } else {
                console.log('no target specified or missing class');
            }
        }));

        document.body.addEventListener('click', Tools.delegate('[data-toggle-self]', e => {
            let self = e.target.closest('[data-toggle-self]');
            self.classList.toggle(self.dataset.toggleSelf);

            e.preventDefault();
        }));
    });
});
